'use client';

import { type QueryObserverResult, useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'next/navigation';
import { useState } from 'react';

import { RatesSearchParams } from '@/app/components/rates-and-prices-listing/rates-prices.types';
import { type PricingResponse, getPricing } from '@/app/queries/get-pricing';

const usePricingLookup = (): {
  data: PricingResponse | undefined;
  isLoading: boolean;
  postcode: string;
  planID: string;
  searchParam: RatesSearchParams;
  refetch: () => Promise<QueryObserverResult>;
  setPostcode: (_: string) => void;
  setPlanID: (_: string) => void;
  setSearchParam: (_: RatesSearchParams) => void;
} => {
  // if we have a query string in the URL, set it to be planID

  const searchParams = useSearchParams();

  const queryParamPlanID = searchParams.get('planID') || '';

  const [postcode, setPostcode] = useState('');
  const [planID, setPlanID] = useState(queryParamPlanID);
  const [searchParam, setSearchParam] = useState(
    queryParamPlanID ? RatesSearchParams.PlanID : RatesSearchParams.Postcode
  );

  const ratesListQuery = useQuery({
    queryKey: ['rates', { searchParam, postcode, planID }],
    queryFn: getPricing,
    throwOnError: false,
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(queryParamPlanID),
    gcTime: 0,
  });

  const { data, isLoading, refetch } = ratesListQuery;

  return {
    data,
    isLoading,
    postcode,
    planID,
    searchParam,
    refetch,
    setPostcode,
    setPlanID,
    setSearchParam,
  };
};

export { usePricingLookup };
